import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import {
  bool, element, func, string
} from "prop-types";

function ExportDataBySensorsButton({ tooltipTitle = "Экспорт данных", children, ...iconButtonProps }) {
  return (
    <Tooltip title={tooltipTitle}>
      <IconButton
        {...iconButtonProps}
        aria-haspopup="true"
        color="primary"
      >
        {children}
      </IconButton>
    </Tooltip>
  );
}

ExportDataBySensorsButton.propTypes = {
  disabled: bool.isRequired,
  onClick: func.isRequired,
  children: element.isRequired,
  // eslint-disable-next-line react/require-default-props
  tooltipTitle: string,
  // eslint-disable-next-line react/require-default-props
  className: string,
};

export default React.memo(ExportDataBySensorsButton);
